import * as OpportunitiesActions from "./opportunitiesActions";

export default OpportunitiesActions;



// WEBPACK FOOTER //
// ./src/actions/OpportunitiesActions/index.js